import { Injector, Component, OnInit, Input, HostListener } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { LayoutService } from '../../../Services/layout/layout.service';
import * as bowser from 'bowser';
import { find } from 'lodash';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { EventsComponent } from '../events/events.component';
@Component({
	selector: 'call-progressive',
	template: `
		<analyzed-element>
			<section *ngIf="!this.showSecondOnlineBuy && !shouldShowCallMeNow" class="call-us">
				<h2>
					Call Progressive to customize or buy<br />
					<span tabindex="0" *ngIf="!Mobile()" (keydown.enter)="phoneClick()" (click)="phoneClick()">{{
						control.phoneNumber
					}}</span>
					<a
						*ngIf="Mobile()"
						[href]="dialNumber"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="Call_Progressive"
						[value]="dialNumberReplace()"
						action="LinkClick"
						(click)="phoneClick()"
					>
						{{ control.phoneNumber }}</a
					>
				</h2>
				<h3>(All your quote information is saved)</h3>
			</section>
			<div *ngIf="shouldShowCallMeNow" class="call-me-now-wrapper">
				<p class="call-me-now-first-row">Experts are ready to help customize or buy your policy</p>
				<p class="call-me-now-second-row">Quote Number: {{ quoteNumber }}</p>
				<a tabindex="0" [href]="dialNumber" (keydown.enter)="phoneClick()" (click)="phoneClick()">
					{{ control.phoneNumber }}
				</a>

				<div
					class="call-me-now-prim-wrapper"
					*ngIf="shouldShowCallMeNow && this.control.attributes.showCallMeNowButton"
				>
					<a class="callNowPrimBtn" action="LinkClick" (click)="callMeNowClick()">Call me now</a>
					<app-popup name="Popup.TalkWithUsBottom"></app-popup>
				</div>
			</div>
		</analyzed-element>
	`,
	styleUrls: ['./call-pregressive.component.scss'],
})
export class CallProgressiveComponent extends EventsComponent implements OnInit {
	dialNumber: string;
	showSecondOnlineBuy: boolean;
	selectedOption: any;
	shouldShowCallMeNow: boolean = false;
	quoteNumber: string;

	constructor(private LayoutService: LayoutService, private actionApiService: ActionApiService, injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.selectedOption = this.storeService.getValue('CarrierInformation', this.context);
		this.LayoutService.globalAttributes.subscribe((data) => {
			if (data) {
				this.shouldShowCallMeNow = data.shouldShowCallMeButtonBottom;
				this.quoteNumber = data.applicationId.value;
			}
		});
		this.dialNumber = 'tel:' + this.control.phoneNumber;

		this.observablesService.OnlineBuyActive.subscribe((res) => {
			this.showSecondOnlineBuy = res;
			this.setCallProgressiveStyle();
		});
	}

	Mobile() {
		return bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile';
	}

	dialNumberReplace() {
		return this.dialNumber ? this.dialNumber.replace('tel:', '') : '';
	}

	callMeNowClick() {
		const newObject = {};
		Object.keys(this.selectedOption).forEach((oldKey) => {
			delete Object.assign(newObject, this.selectedOption, { ['CarrierInformation.' + oldKey]: newObject[oldKey] })[
				oldKey
			];
		});
		const requestBody: request = {
			data: newObject,
			info: {
				action: 'TalkWithUs',
				conditions: '',
				elementSrc: 'show_bottom',
				stage: 'Enter_Phone_1',
				notRenderPage: false,
			},
			isRemoteAction: true,
		};
		this.actionApiService.invokeAction(requestBody);
	}

	setCallProgressiveStyle() {
		var elem = this.elementRef.nativeElement.parentElement.parentElement;
		if (!this.showSecondOnlineBuy) {
			this.Renderer.setStyle(elem, 'display', 'inline-block');
		} else {
			this.Renderer.setStyle(elem, 'display', 'none');
			this.Renderer.setStyle(elem.parentElement, 'margin-bottom', '0');
		}
	}

	phoneClick() {}
}
